import React from "react";
import { Navigate } from "react-router-dom";

// =====================================================
// AUTH
// =====================================================

import Login from "../pages/Authentication/Login";

import Dashboard from "../pages/Dashboard/Dashboard";

// Leads
import AllLeads from "../pages/Leads/AllLeads";
import LeadDetails from "../pages/Leads/LeadDetails";
import NewLeads from "../pages/Leads/NewLeads";
import FollowUps from "../pages/Leads/FollowUps";
import Counselling from "../pages/Leads/Counselling";


// Marketing
import Campaigns from "../pages/Campaigns/Campaigns";
import CampaignDetails from "../pages/Campaigns/CampaignDetails";
import LeadSources from "../pages/LeadSources/LeadSources";
import Analytics from "../pages/Analytics/Analytics";

// Communications
import WhatsApp from "../pages/WhatsApp/WhatsApp";
import Conversations from "../pages/Conversations/Conversations";

// Admissions
import Applications from "../pages/Admissions/Applications";
import ApplicationDetails from "../pages/Admissions/ApplicationDetails";
import Admissions from "../pages/Admissions/Admissions";

// Integrations
import MetaIntegration from "../pages/Integrations/Meta";
import GoogleIntegration from "../pages/Integrations/Google";
import YouTubeIntegration from "../pages/Integrations/YouTube";
import WhatsAppIntegration from "../pages/Integrations/WhatsApp";

// Settings
import OrganizationSettings from "../pages/Settings/Organization";
import UsersSettings from "../pages/Settings/Users";
import StatusSettings from "../pages/Settings/Statuses";
import PublicLeadSettings from "../pages/Settings/PublicLeads";
import AuditLogs from "../pages/Settings/AuditLogs";

Profile
import Profile from "../pages/Profile/Profile";

import CampaignCreatePage from "../pages/Campaigns/CampaignCreatePage";
import MarketingAssetsPage from "../pages/Campaigns/MarketingAssetsPage";


// =====================================================
// AUTH HELPER
// =====================================================

const isAuthenticated = () => {
  const token = localStorage.getItem("token");

  return !!token;
};


// =====================================================
// AUTH PROTECTED ROUTES
// =====================================================

const authProtectedRoutes = [

  // ---------------------------------------------------
  // DASHBOARD
  // ---------------------------------------------------

  {
    path: "/dashboard",
    component: <Dashboard />,
  },


  // ---------------------------------------------------
  // LEADS
  // ---------------------------------------------------

  {
    path: "/leads",
    component: <AllLeads />,
  },

  {
    path: "/leads/:id",
    component: <LeadDetails />,
  },

  {
    path: "/leads/new",
    component: <NewLeads />,
  },

  {
    path: "/leads/follow-ups",
    component: <FollowUps />,
  },

  {
    path: "/leads/counselling",
    component: <Counselling />,
  },



  // ---------------------------------------------------
  // MARKETING
  // ---------------------------------------------------

  {
    path: "/campaigns",
    component: <Campaigns />,
  },

  {
    path: "/campaigns/:id",
    component: <CampaignDetails />,
  },

  {
    path: "/lead-sources",
    component: <LeadSources />,
  },

  {
    path: "/analytics",
    component: <Analytics />,
  },


  // ---------------------------------------------------
  // COMMUNICATIONS
  // ---------------------------------------------------

  {
    path: "/whatsapp",
    component: <WhatsApp />,
  },

  {
    path: "/conversations",
    component: <Conversations />,
  },


  // ---------------------------------------------------
  // ADMISSIONS
  // ---------------------------------------------------

  {
    path: "/applications",
    component: <Applications />,
  },

  {
    path: "/applications/:id",
    component: <ApplicationDetails />,
  },

  {
    path: "/admissions",
    component: <Admissions />,
  },


  // ---------------------------------------------------
  // INTEGRATIONS
  // ---------------------------------------------------

  {
    path: "/integrations/meta",
    component: <MetaIntegration />,
  },

  {
    path: "/integrations/google",
    component: <GoogleIntegration />,
  },

  {
    path: "/integrations/youtube",
    component: <YouTubeIntegration />,
  },

  {
    path: "/integrations/whatsapp",
    component: <WhatsAppIntegration />,
  },


  // ---------------------------------------------------
  // SETTINGS
  // ---------------------------------------------------

  {
    path: "/settings/organization",
    component: <OrganizationSettings />,
  },

  {
    path: "/settings/users",
    component: <UsersSettings />,
  },

  {
    path: "/settings/statuses",
    component: <StatusSettings />,
  },

  {
    path: "/settings/public-leads",
    component: <PublicLeadSettings />,
  },

  {
    path: "/settings/audit-logs",
    component: <AuditLogs />,
  },


  // ---------------------------------------------------
  // PROFILE
  // ---------------------------------------------------

  {
    path: "/profile",
    component: <Profile />,
  },

    {
    path: "/campaigns/create",
    component: <CampaignCreatePage />,
  },

  {
    path: "/campaigns/:id/edit",
    component: <CampaignCreatePage />,
  },

  {
    path: "/marketing/assets",
    component: <MarketingAssetsPage />,
  },

];


// =====================================================
// PUBLIC ROUTES
// =====================================================

const publicRoutes = [

  {
    path: "/login",
    component: <Login />,
  },

];


// =====================================================
// DEFAULT ROUTES
// =====================================================

// Root route
const rootRoute = {
  path: "/",
  component: isAuthenticated()
    ? <Navigate to="/dashboard" replace />
    : <Navigate to="/login" replace />,
};


// Unknown route
const notFoundRoute = {
  path: "*",
  component: isAuthenticated()
    ? <Navigate to="/dashboard" replace />
    : <Navigate to="/login" replace />,
};


// Add default routes to protected routes
authProtectedRoutes.push(rootRoute);
authProtectedRoutes.push(notFoundRoute);


// =====================================================
// EXPORT
// =====================================================

export {
  authProtectedRoutes,
  publicRoutes,
};